import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button, MessagePlugin, Row } from 'tdesign-react';
import { useNavigate } from 'react-router-dom';
import qs from 'qs';
import { fetchClusterList } from '@/slices/resourceSlice';
import Right from '@/pages/Maintenance/Resource/Host/HostList/Right';

function MaintainHostsStep({
  clusterId,
  fetchClusterList,
  quickDeployFlow,
  clusterType,
  clusterInfo,
}) {
  const navigate = useNavigate();

  useEffect(() => {
    fetchClusterList();
  }, [fetchClusterList]);

  const doNext = () => {
    const { host } = quickDeployFlow;
    if (!host) {
      MessagePlugin.warning('未找到执行流程');
      return;
    }
    const params = {
      flowId: host.id,
      flowType: clusterType,
      envId: clusterInfo.opsEnvId,
      clusterId: clusterInfo.cluster,
    };
    navigate(`/maintenance/executive/flow/detail${qs.stringify(params, { addQueryPrefix: true })}`);
  };

  return (
    <Root>
      <Right clusterId={clusterId} />
      <Row justify='end' align='middle' style={{ marginTop: 20 }}>
        <Tip>请按照后续说明分配主机，并填写变量</Tip>
        <Button onClick={doNext}>开始配置</Button>
      </Row>
    </Root>
  );
}

export default connect(
  (state) => ({
    clusterId: state.cluster.quickDeploy.clusterInfo.cluster,
    quickDeployFlow: state.execFlow.quickDeployFlow,
    clusterInfo: state.cluster.quickDeploy.clusterInfo,
    clusterType: state.cluster.quickDeploy.clusterType,
  }),
  {
    fetchClusterList,
  },
)(MaintainHostsStep);

const Root = styled.div`
  margin-top: 20px;
`;

const Tip = styled.div`
  color: var(--td-text-color-secondary);
  margin-right: 16px;
`;
